export default "__VITE_ASSET__eYlGQidr__";